import { Expose, Type } from 'class-transformer';
import {
  CommonParamInput,
  MinimalCommonModel,
} from 'common/repositories/common.model';

// Model

export class RoleLiteModel {
  id: string;
  name: string;
}

export class RoleModel extends RoleLiteModel {
  @Expose({ name: 'permission_groups' })
  permissionGroups: string[];
}

export class PermissionCategoryModel {
  category: string;

  @Expose({ name: 'permission_groups' })
  @Type(() => MinimalCommonModel)
  permissionGroups: MinimalCommonModel[];
}

export class PermissionGroupModel {
  group: string;

  @Expose({ name: 'categories' })
  @Type(() => PermissionCategoryModel)
  categories: PermissionCategoryModel[];
}

// Input

export class getRolesInput {
  params: CommonParamInput;
}

export class getRoleInput {
  id: string;
}

export class RoleCreateInput {
  name: string;
  permissions: string[];
}

export class RoleMutationInput {
  name: string;
  permissions: string[];
}

export class RoleUpdateInput {
  roleId: string;
  body: RoleMutationInput;
}

export class RoleDeleteInput {
  roleId: string;
}
